<template>
    	<el-form :model="vo" @submit.native.prevent>
	    <div style="width:100%;" class="el-table el-table--fit el-table--border">
	      <div class="el-table__body-wrapper">
	        <table cellspacing="0" cellpadding="0" border="0" class="el-table__body ">
	          <tbody>
	          	<tr>
	          		<td ref="tdlbl_称谓" class="el-table__cell tdlbl tdw17" colspan="1">
	          			<span class="required">*</span>
	                    <span v-field-lbl="'relationship'" class="field">称谓</span>
	                </td>
	          		<td class="el-table__cell tdcont tdw83" colspan="5">
	          				<form-item ref="relationship" :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'0：父亲\n1：母亲\n2：配偶\n3：子女\n4：其他','elementReadonly':1,'elementType':'select','emptyMessage':'请选择称谓','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'称谓','propName':'relationship','propType':'String','textFormatter':null,'valueMaxLength':4,'valueMinLength':null,'model':'vo.relationship','option':[{'value':'0','name':'父亲'},{'value':'1','name':'母亲'},{'value':'2','name':'配偶'},{'value':'3','name':'子女'},{'value':'4','name':'其他'}],'optionGenerateType':0,'clearable':false,'filterable':false,'allowCreate':false}" :vo="vo" :can-edit="canEdit" />
	                </td>
	          	</tr>
	          	<tr>
	          		<td ref="tdlbl_家庭成员姓名" class="el-table__cell tdlbl tdw17" colspan="1">
	          			<span class="required">*</span>
	                    <span v-field-lbl="'familyMemberName'" class="field">家庭成员姓名</span>
	                </td>
	          		<td class="el-table__cell tdcont tdw83" colspan="5">
	          				<form-item ref="familyMemberName" :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'请输入家庭成员姓名','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'家庭成员姓名','propName':'familyMemberName','propType':'String','textFormatter':'textfield','valueMaxLength':50,'valueMinLength':null,'model':'vo.familyMemberName','option':[],'autocomplete':'off','dialog':0,'showWordLimit':false}" :vo="vo" :can-edit="canEdit" />
	                </td>
	          	</tr>
	          	<tr>
	          		<td ref="tdlbl_出生年月" class="el-table__cell tdlbl tdw17" colspan="1">

	                    <span v-field-lbl="'family.birthday'" class="field">出生年月</span>
	                </td>
	          		<td class="el-table__cell tdcont tdw83" colspan="5">
	          				<form-item ref="family.birthday" :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'','elementReadonly':1,'elementType':'date','emptyMessage':'','errorMessage':null,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'出生年月','propName':'family.birthday','propType':'java.util.Date','textFormatter':'yyyy-MM-dd','valueMaxLength':null,'valueMinLength':null,'tbFieldName':'family.birthday','iconName':'rqxzk','model':'vo.family.birthday','option':[],'formTdAlign':'text-left','weekday':0,'formTdColspan':24}" :vo="vo" :can-edit="canEdit" />
	                </td>
	          	</tr>
	          	<tr>
	          		<td ref="tdlbl_身份证号码" class="el-table__cell tdlbl tdw17" colspan="1">

	                    <span v-field-lbl="'familyIdCardNumber'" class="field">身份证号码</span>
	                </td>
	          		<td class="el-table__cell tdcont tdw83" colspan="5">
	          				<form-item ref="familyIdCardNumber" :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'请输入教师身份证号','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'身份证号码','propName':'familyIdCardNumber','propType':'String','textFormatter':'textfield','valueMaxLength':18,'valueMinLength':null,'model':'vo.familyIdCardNumber','option':[],'autocomplete':'off','dialog':0,'showWordLimit':false,'tbFieldName':'familyidcardnumber'}" :vo="vo" :can-edit="canEdit" />
	                </td>
	          	</tr>
	          	<tr>
	          		<td ref="tdlbl_政治面貌" class="el-table__cell tdlbl tdw17" colspan="1">

	                    <span v-field-lbl="'politicalStatus'" class="field">政治面貌</span>
	                </td>
	          		<td class="el-table__cell tdcont tdw83" colspan="5">
	          				<form-item ref="politicalStatus" :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'0：中共党员\n1：中共预备党员\n2：共青团员\n3：群众','elementReadonly':1,'elementType':'select','emptyMessage':'','errorMessage':null,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'政治面貌','propName':'politicalStatus','propType':'String','textFormatter':null,'valueMaxLength':50,'valueMinLength':null,'tbFieldName':'politicalstatus','iconName':'xialakuang','model':'vo.politicalStatus','option':[{'value':'0','name':'中共党员'},{'name':'中共预备党员','value':'1'},{'name':'共青团员','value':'2'},{'name':'群众','value':'3'}],'formTdAlign':'text-left','formTdColspan':24,'optionGenerateType':0,'clearable':false,'filterable':false,'allowCreate':false}" :vo="vo" :can-edit="canEdit" />
	                </td>
	          	</tr>
	          	<tr>
	          		<td ref="tdlbl_工作单位以及职务" class="el-table__cell tdlbl tdw17" colspan="1">

	                    <span v-field-lbl="'workUnitAndPosition'" class="field">工作单位以及职务</span>
	                </td>
	          		<td class="el-table__cell tdcont tdw83" colspan="5">
	          				<form-item ref="workUnitAndPosition" :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'请输入工作单位以及职务','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'工作单位以及职务','propName':'workUnitAndPosition','propType':'String','textFormatter':'textfield','valueMaxLength':255,'valueMinLength':null,'model':'vo.workUnitAndPosition','option':[]}" :vo="vo" :can-edit="canEdit" />
	                </td>
	          	</tr>
	          </tbody>
	        </table>
          </div>
	    </div>
	 </el-form>
</template>

<script>
export default {
 	props: {
 	    vo: { type: Object, default: function() { return {} } },
        canEdit: { type: Number, default: 1 },
        moduleInfo: { type: Object, default: function() { return {} } }
    },
    data: function() {
        return {
        	loginUser: this.$store.getters.loginUser
        }
    },
    computed: {
    },
    watch: {
    },
    created: function() {
        if (this.$parent.$vnode.context.activeTabIndex) {
            this.activeTabName = this.$parent.$vnode.context.activeTabIndex
        }

	    this.$set(this.$vnode.context, 'wfAttach', false)
    },
    beforeDestroy: function() {
    },
    mounted: function() {
    },
    methods: {

    }
}
</script>

<style scoped>
</style>
